module.exports = __webpack_public_path__ + "static/15-c82dd8786e2eda883a4cb2d73708a684.wav";